import React, { useEffect, useMemo } from "react";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import { useNavigate, useParams } from "react-router-dom";
import { CancelButton, SaveAndUpdate } from "../../utils/commonComponent/Custom/Button";
import OfficeModal from "./officeModal";
import { handleInwardSubmit } from "./submitHandler";
import { fetchDisciplineDetails, fetchDisciplineGroupDetails, fetchInwardCSRFDetails, fetchInwardDetails, fetchInwardOfficeDetails, fetchInwardTestRows, fetchJobDetails, fetchJobRegisterDetails, fetchSettings, fetchUnitListdisGrpWise, lastInwardRefNo } from "./fetchHandler";
import { DisciplineOptions, DispatchModeOptions } from "../disciplineMaster/disiplineConst";
import { locationFacility } from "../testMaster/testConstant";
import TestRowComponent from "./testRowComponent";
import { getPermissions } from "../rbac/hasAccess";
import CSRFForm from "./csrfForm";

const EditInward = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});
  const [officeFormData, setOfficeFormData] = React.useState({});
  const [disgroupList, setDisGroupList] = React.useState([]);

  const [materialList, setmaterialList] = React.useState([]);
  const [unitList, setunitList] = React.useState([]);
  const [testRows, setTestRows] = React.useState([]);
  const [deletedIds, setDeletedIds] = React.useState([]);
  const [jobList, setJobList] = React.useState([]);
  const [settingList, setSettingList] = React.useState([]);

  const [csrfFormPayload, setCSRFFormPayload] = React.useState({});
  const [CSRFFetchData, setCSRFFetchData] = React.useState([]);
  
  const inputFields = [
    {
      type: "Autocomplete",
      label: "Location *",
      stateKey: "location",
      options: locationFacility,
      valueKey: "id",
      getOptionLabelKey: "label",
      disabled: params.id != 0,
    },
    {
      type: "Autocomplete",
      label: "Job *",
      stateKey: "jobId",
      options: "jobRegister",
      valueKey: "id",
      getOptionLabelKey: "jobNumber",
      disabled: params.id != 0,
    },
    {
      type: "DatePicker",
      label: "Job Date",
      stateKey: "jobDate",
      disabled: true,
    },
    { type: "TextField", label: "Customer Name", stateKey: "customerName", disabled: true },
    { type: "TextField", label: "Address", stateKey: "address", disabled: true },
    { type: "TextField", label: "Contact Person", stateKey: "contactPerson", disabled: true },
    { type: "Textarea", label: "Principle Client", stateKey: "principleClient", disabled: true },
    { type: "DatePicker", label: "Inward Date *", stateKey: "inwardDate", disableFutureDates: true },
    {
      type: "Autocomplete",
      label: "Dispatch Mode",
      stateKey: "dispatchMode",
      options: DispatchModeOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      showWhenLocationIs2: true,
    },
    { type: "DatePicker", label: "Estimated Start Date Of Testing", stateKey: "testingStartDate", disablePastDates: true, minimumDate: inputStates.inwardDate, showWhenLocationIs2: true, },
    { type: "DatePicker", label: "Estimated Report Delivery Date", stateKey: "reportDeliveryDate", disablePastDates: true, minimumDate: inputStates.inwardDate, showWhenLocationIs2: true, },
    {
      type: "Autocomplete",
      label: "Discipline *",
      stateKey: "disciplineId",
      options: DisciplineOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      disabled: params.id != 0,
      showWhenLocationIs2: true,
    },
    { type: "TextField", label: "Lab Ref. No.", stateKey: "labReferenceNo", disabled: true },
  ];
  /* ---------------- FILTER INPUT FIELDS ---------------- */
  const filteredInputFields = useMemo(() => {
    return inputFields.filter(field => {
      if (field.showWhenLocationIs2) {
        return inputStates.location != 2;
      }
      return true;
    });
  }, [inputStates.location]);

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  // update office form fields
  const handleOfficeChange = (key, value) => {
    setOfficeFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (inputStates?.jobId) {
      fetchJobDetails(inputStates?.jobId, updateInputObject, params);
    }
  }, [inputStates?.jobId, params]);

  useEffect(() => {
    if (inputStates?.disciplineId) {
      fetchDisciplineDetails(inputStates, setDisGroupList);
      if (inputStates?.groupId) {
        fetchDisciplineGroupDetails(inputStates, setmaterialList);
        fetchUnitListdisGrpWise(inputStates, setunitList);
      }
    }
  }, [inputStates?.disciplineId, inputStates?.groupId]);

  useEffect(() => {
    if (params.id != 0) {
      fetchInwardDetails(params, setInputStates);
      fetchInwardOfficeDetails(params, setOfficeFormData);
      fetchInwardTestRows(params, setTestRows);
      fetchInwardCSRFDetails(params, setCSRFFetchData);
    }
    fetchSettings(setSettingList);
  }, [params.id]);

  useEffect(() => {
    if (params.id == 0) {
      lastInwardRefNo(updateInputObject, inputStates, settingList);
      fetchJobRegisterDetails(setJobList);
    }
  }, [params.id, inputStates.location, inputStates.disciplineId]);

  return (
    <>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Inward" : `Update Inward `}
      </Text>
      
      <br />

      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={filteredInputFields}
      />

      <br />

      <TestRowComponent
        params={params}
        materialList={materialList} unitList={unitList}
        testRows={testRows}
        setTestRows={setTestRows}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        // extraColumns={[]}
        permissions={permissions}
        disgroupList={disgroupList}
        inputStates={inputStates}
      />

      <br />

      {settingList && settingList?.find((item) => item.keyName === "inwardCSRF")?.value === "true" ? (
        <CSRFForm
          setCSRFFormPayload={setCSRFFormPayload}
          CSRFFetchData={CSRFFetchData}
        />
      ) : (
        inputStates.location != 2 && (
          <OfficeModal
            formData={officeFormData}
            handleChange={handleOfficeChange}
          />
        )
      )}

      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton id="btn-cancel" label="Cancel" outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
       {(permissions.save || permissions.allAccess) && (
        <SaveAndUpdate id="btn-add-outline" label={params.id == 0 ? "Save" : "Update"} onClick={() =>
          handleInwardSubmit(params, inputStates, officeFormData, testRows, deletedIds, settingList, csrfFormPayload, CSRFFetchData, navigate)
        }
        />
        )}  
      </div>
    </>
  );
};

export default EditInward;
